export default "__VITE_ASSET__BR7pth3e__"